import React from 'react';
import {Record} from '../../../../../stores/Form';

export type LocationType = {
    id: string;
    group?: string;
    row?: number;
};

export type DNDState = {
    isMoving: boolean;
    setIsMoving: (value: boolean) => void;
    setCoordinates: React.Dispatch<React.SetStateAction<[number, number]>>;
    from?: LocationType;
    setFrom: React.Dispatch<React.SetStateAction<LocationType>>;
    to?: LocationType;
    setTo: React.Dispatch<React.SetStateAction<LocationType>>;
    coordinates?: [number, number];
    setMovingRecords: React.Dispatch<React.SetStateAction<Record[]>>;
    movingRecords?: Record[];
};

export const DNDContext = React.createContext<DNDState>({
    isMoving: false,
    setIsMoving: () => {},
    setCoordinates: () => {},
    setFrom: () => {},
    from: undefined,
    setTo: () => {},
    to: undefined,
    setMovingRecords: () => {},
    movingRecords: undefined,
    coordinates: undefined
});
